<template>
	<v-row
		justify = "center"
		align 	= "center"
	>
		<v-col
			xl 	  = "10"
			lg    = "10"
			md 	  = "11"
			sm 	  = "12"
			xs 	  = "12"
			cols  = "12"
		>
			<v-card 
			 	outlined
			>
				<v-card-title
					class = "secondary pa-1 subtitle-1 white--text text-uppercase font-weight-medium"
				>
					<v-icon 
						 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					
					<v-spacer></v-spacer>

					<v-icon
						
						color  = "primary"
						v-text = "'mdi-map-marker-star'" 
						class  = "mx-1"
					></v-icon>

					<span>
						{{ $ml.get(title) }}						
					</span>

					<v-spacer></v-spacer>
					
				
				</v-card-title>
				<v-card-text
					class = "pa-1"
				>
					<v-row>
						
						<v-col>
							<v-card 
								outlined
							>
								<v-card-title
									class = "pa-0 pl-2  primary body-1 white--text font-weight-medium text-uppercase"
								>	
									<v-icon
										small
										color = "white"
										class = "mx-1"
									>
										mdi-map-marker-plus
									</v-icon>
									<span
										v-text = "$ml.get('zone')"
									></span>
									
									<v-spacer></v-spacer>

								</v-card-title>	
								<v-card-text
									class = "pa-1 "
								>
								<v-row
									no-gutters
									justify = "center"
									align   = "center"
								>	
									<template
										v-for = "(item_field, idx_field) of info_fields "
										v-if  = "item_field.enable"

									>						
										<v-col 
											cols = "11"
											:key = "idx_field"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if      = "item_field.type == 'text'"
												v-model   = "info[item_field.key]"
												:label    = "$ml.get(item_field.text)"	
												type      = "text"
												class     = "mt-2"
												:disabled = "item_field.able"
											></v-text-field>
											<v-text-field
												dense
												outlined 
												hide-details
												v-if 	 	   = "item_field.type == 'number'"
												type 		   = "number"
												v-model.number = "info[item_field.key]"
												:label 		   = "item_field.text"
												class 		   = "mt-2"
												:disabled 	   = "item_field.able"
											></v-text-field>
											<v-select
												dense
												outlined
												hide-details
												return-object
												v-if 	  	= "item_field.type == 'select'"
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listed(item_field.list)"
												item-text 	= "name"
												:multiple 	= "item_field.multiple"
												class 		= "my-1"
												v-show 		= "!item_field.show"
												
											>
												<template v-slot:selection="{ item, index }">
											        <v-chip 
											        	x-small 
											        	v-if = "index < 3"
											        >
											          	{{ item.name ? item.name : item }}
											        </v-chip>
											        <span
											          v-if  = "index == 4"
											          class = "grey--text caption"
											        >
											          (+{{ info[item_field.key].length - 3 }} others)
											        </span>
											      </template>
											</v-select>
											<v-file-input
											    dense
											    outlined
												hide-details 					
											    v-if 		 = "item_field.type == 'file'"
												class 		 = "mt-1"
											    :label    	 = "$ml.get(item_field.text)"
											    v-model 	 = "info[item_field.key]"
											    :placeholder = "image_placeholder"
												prepend-icon = "mdi-camera"		
											>
												<!-- append-icon  = "mdi-upload" -->
												<!-- @click:append = "" -->
												<template 
													v-slot:append
												>
              										<v-fade-transition 
              											leave-absolute
              										>
              											 <v-tooltip
											                top
											              >
											                <template 
											                	v-slot:activator = "{ on }"
											                >
											                  	<v-icon 
											                  		v-on    = "on"	
											                  		v-show  = "!show_progress"
											                  		@click  = "actions('save_image')"
											                  		:color  = "info.url_image ? 'success' : ''"
											                  	>
											                    	mdi-upload
											                  	</v-icon>
											                </template>
											                {{ $ml.get('upload_imagen')}}
											              </v-tooltip>
              										</v-fade-transition>
              									</template>
											</v-file-input>	

											<!-- <v-img
											  		contain
											  		v-if  = "info[item_field.key] && item_field.type == 'file'"
											  		:src  = "info[item_field.key]"
											  		width = "100"
											></v-img> -->
											<v-card outlined 
												class 	= "pa-0 caption pb-1 mt-1 pl-1" 
												height 	= "40"
												v-if 	= "item_field.type == 'switch'"
											>
											<v-switch			
												dense						
												false-value
												hide-details
												class 			= "mt-1"			
												v-model 		= "info[item_field.key]"
												:label 			= "$ml.get(item_field.text)"
											></v-switch>
												<!-- :prepend-icon 	= "item_field.icon" -->
												<!-- v-if="item_field.type == 'switch'"						 -->
												<!-- class="pt-0" -->
										</v-card>
										</v-col>
									</template>

									<v-col
										cols  = "12"
										v-if  = "info"
										class = "mt-2"
										style = "height : 285px"
									>
											<!-- :selected_type 			= "info.type_zone" -->
										<zone
											v-show 					= "show.zone" 
											:info_to_constellation 	= "null"
											:is_edit 				= "true"
											:info_to_component 		= "info"
											:check_update 			= "info.device"
											:actions_component  	= "actions_comp"
											@receive_info 			= "actions('render_points', $event)"
										></zone>
									</v-col>

								</v-row>

								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<!-- <v-spacer></v-spacer> -->

									<v-progress-circular
								      	indeterminate
								      	color 	= "primary"
								      	v-show 	= "show_progress"
								    	:size 	= "20"
								    	:width 	= "4"
								    ></v-progress-circular>

								    <!-- <v-btn
										x-small
										
										color 	= ""
										v-text 	= "'test'"	
										@click 	= "actions('test')"
									></v-btn> -->
									<v-spacer></v-spacer>
									<v-btn	
										small
								    	class 	= "mx-1"
										v-show 	= "!show_progress"
										color 	= "primary"
										v-text 	= "$ml.get(btn_option)"	
										@click 	= "actions(btn_option)"
									></v-btn>
									
									<v-spacer></v-spacer>

									<!-- <v-btn
										x-small
										color 		= "error"
										:disabled 	= "btn_option == 'update' ? false : true"
										v-text		= "$ml.get('delete')"						
										@click 	 	= "actions('delete')"
									></v-btn> -->
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col
							cols = "5"
						>

							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2 white--text"
					    		>	
					    			{{ $ml.get('registered_devices') }}
					    		</v-toolbar-title>
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
								show-select
							    fixed-header
								:headers 				= "header_table"
								:items 					= "render_list"
								class 					= "elevation-5"
							   	loading-text 			= "Loading... Please wait"
							   	:loading 				= "false"
							    item-key 				= "id"
							    :height 				= "layout_height+'px'"
							    v-model 				= "info.device"
								:options.sync 			= "options"
							   	:server-items-length 	= "total"
							   	:footer-props 			= "{
							   		showFirstLastPage 	: false,
							   		itemsPerPageOptions : [total],/*15, 30*/
							   		itemsPerPage  		: total,
							   		showCurrentPage 	: false,
							   		itemsPerPageText 	: ''
							   	}"

							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.actions = "{ item }" >
									<!--<v-btn
										x-small
										color  = "primary"
										@click = "redirect_setting(item)"
									>
										<v-icon
											x-small
											v-text = "'mdi-pencil'"
										></v-icon>
									</v-btn>	
									 <v-btn
										x-small
										color="primary"
										@click="redirect(item)"
									>
										<v-icon
											x-small
											v-text="'mdi-pencil'"
										></v-icon>
									</v-btn>			 -->				
								</template>
								 <template v-slot:top >
								    	<v-row 
								    		no-gutters
								    	>
								    		<v-col>
								    			<searcher
													
													:info_to_component = "item_search"
													:info_to_list  	   = "list_device"
													@receive_info	   = "listed = $event"
												></searcher>
								    		</v-col>
								    	</v-row>
								    </template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import list_dev from '@/components/tester/jsons/list_devices_test.json'
	import EventBus from '@/event-bus'
	import zone 	from '@/components/zones/zones.vue'
	import searcher from "@/components/info/searcher.vue"

	export default{
		name 		: 'settings_zones',
		components 	: {
			zone,
			searcher,
		}, // componentes
		data 		: (vn) => ({
			info : {
				points : "",
			},
			title 		 : 'new_zone',
			header_table : [
				{ text: vn.$ml.get('device'), value: 'name' },
				// { text: 'type', value: 'type' },
				// { text: 'actions', value: 'actions' , align: 'center' },
			],
			options 		: { itemsPerPage : 30},
			total 			: 1,
			layout_height 	: 400,
			option_conts 	: [
				{ 
					title  		: 'New', 
					color 		: 'primary', 
					enable 		: true, 
					btn_action 	: 'new', 
					key 		: 'new'  
				},
			],
			list_device 	: [], 
			device_selected : [],
			info_fields 	: [
				{
					key 	: 'name',
					text 	: 'name',
					type 	: 'text',
					enable	: true,
					able 	: false,
				},
				{
					key 	: 'ID',
					text 	: 'id',
					type 	: 'text',						
					enable 	: false,
					able 	: true,
				},
				{
					key 	: 'device',
					text 	: 'devices',
					type 	: 'select',
					list 	: 'list_device',
					enable 	: true,
					show 	: true,
					multiple : true,


				},
				{
					key  	: 'image_file',
					text 	: 'background_image',
					type 	: 'file',				
					enable 	: true,
				},
				{
					key  	: 'url_image',
					text 	: 'background_image',
					type 	: 'img',
					enable 	: false,
				},
				{
					key  	: 'icon_color',
					text 	: 'color',
					type 	: 'select',
					list 	: 'list_colors',
					enable 	: true,
					multiple : false,
				},
				{
					key  	: 'type_zone',
					text 	: 'edit_zone',
					type 	: 'switch',
					enable 	: true,
				},

			],
			btn_option 		: 'save',
			list 			: [], // list constellation
			show_progress 	: false,
			devs_selecteds 	: [],
			show 			: {
				zone : true,
			}, 
			item_search	: {
				key 		: 'search',
				text 		: 'search',
				placeholder : 'device',
				list 		: 'list_device',
				key_list	: 'deviceId',
				text_list 	: 'name',
				type 		: 'field_searcher',
				key_search  : 'name',
				key_search_1 : 'deviceId',
				visible 	: true,
				cols 		: {
					col : 2,
				},
			},
			listed 		: [],
			list_colors  : [ 'green', 'black', 'white'],
			check_fields : [
				'name',
				'device',
				'type_zone',
				'url_image',
				'icon_color'],
			actions_comp 		: '',
			image_placeholder 	: '',
			bus 				: {},
			ID_notification 	: "settings_zones",
		}), // data

		watch:{
			options:{
				handler(){
					this.get_devices();
				}, deep: true,
			}, // options


		}, // watch	


		created(){

			this.get_list();

		}, // created

		methods:{

			actions(act, item){
				let info_up = this.info//item ? item : null; 
				this.show_progress = true;
				if (act == 'save') {
					this.actions_comp = act;		
					const timer = setTimeout(()=>{
						this.save();
						clearTimeout(timer);
					}, 250);			
				}
				if (act == 'update') {
					this.actions_comp = act;					
					const timer = setTimeout(()=>{
						this.update();
						clearTimeout(timer);
					}, 250);			
				}
				if (act == 'delete') {

					this.$EventBus.$emit('notifications_modal', { 
						type : 'confirm_delete',
						ID   : info_up.id,
					});
				}

				if (act == 'save_image') {
					this.save_image();
				}
				if (act == 'test') {
					this.actions_comp = act;
				}
				if (act == 'render_points') {
					// console.log("render_points", item)
					this.show_progress = false;
					if (item) {
						try{
							if (item && item.length > 0) {
								let temp = [];
								item.forEach((point)=>{
									temp.push({
										deviceId : point.deviceId,
										name  	 : point.name,
										points   : point.points,
										camPoints : point.camPoints, 
									});
								})
														
								this.info.points = JSON.stringify(temp);;
							}
						}catch(er){
							console.log("Error stringify convert zone points", er);
						}
					}
				}

			}, // actions

			get_list(){
				let temp_option = null;

				// get type of board
				if (localStorage.getItem('constellation_redirect')) {
					temp_option = JSON.parse(localStorage.getItem('constellation_redirect'));
				}
				console.log(temp_option, 'option');

				if (temp_option !== 'new') {
					this.title 		= 'zone_settings';
					this.btn_option = 'update';
					this.info 		= temp_option;
					this.get_constellation();
					// this.get_devices();
				} else{
					// this.get_devices();
				}


				
			}, // get list

			get_constellation(){
				let info_get = this.info;
				const api 	 = this.$URL + '/api/v1/constellation/' + info_get.id;
				this.$axios.get(api).then( res => {
					// console.log(res, 'Res get zone');	

					if (res.data){
						this.info 			 = res.data;	
						if (this.info.url_image) {
							let temp_image = this.info.url_image.split("-");

							console.log("temp_image", temp_image);	
							if (temp_image && temp_image.length > 0) {
								this.image_placeholder =  temp_image[temp_image.length - 1];
							}else{
								this.image_placeholder = this.info.url_image;
							}

						}
						this.devs_selecteds = res.data.device; 					
					}else{

						this.info.name 	= '';
						this.title 		= 'new';
						this.btn_option = 'save';
					}	
					this.get_list_local();
						
					// this.save_local(res.data, false);
				}).catch( er => {
					console.log(er, 'Error get constellation');
					if (er && er.message == "Network Error") {
						console.log(er.message)
						this.$EventBus.$emit('notifications_modal', { 
							type: 'error',
							message: er.message
						});
					}
					// this.get_list_local();

				});
			},

			

			get_list_local(){
				// get list local constellations
				let vl 			= this;
				let search 		= null;
				let info_set 	= null;
				let list_temp 	= [];

				if (localStorage.getItem('constellations')) {
					list_temp = JSON.parse(localStorage.getItem('constellations'));
					this.list = list_temp;
				}	

				const find = list_temp.some( function(arr_list, idx_list){
					if (search == arr_list.ID) {
						info_set = arr_list; 
						return true
					}
				})

				
/*
				// check index device
				if (list_temp  && list_temp.lenght == 0) {
					search = null;//this.layout_id;
					
					const find = vl.list.some( function(arr_list, idx_list){
						if (search == arr_list.id) {
							info_set = arr_list; 
							return true
						}
					})
				}

				this.info = info_set;
*/
				/*if (this.info.name == 'title' && !find) {
					console.log('init')
					this.dialog = false;
					this.info.name = '';
					this.info.ID = this.layout_id;
				}else{
					
				}*/
			}, // list local

			save_image(){

				if (!this.$store.getters["auth/permission"]( this.$route.name || "settings_zones", "can_add", "zones")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_create") + " : " + (this.$ml.get(this.$route.name) || "settings_zones"),
					})						
					this.show_progress = false;

					return false;
				}
				let info_up = this.info;
				if (info_up && info_up.name && info_up.image_file) {


					let formData = new FormData();
					let ext = info_up.image_file && info_up.image_file.type ? info_up.image_file.type.split('/')[1] : 'png';
					let name_file = 'zone' + info_up.name;
					console.log("EXT : " , ext)
				    formData.append("file", info_up.image_file, name_file + '.' + ext/*, info_up.name*/);
				    
				    const api 	 = this.$URL + "/api/v1/zone/image";
					
					this.$axios.post(api, formData).then(res => {
						console.log("saved image file", res);
						this.info.url_image  = res.data.url_path;
						this.info.path_image = res.data.path;
						this.show_progress = false;
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'success',
							message : this.$ml.get('uploaded_image') 
						});
					}).catch( er => {
						console.log("Erro upload image zone ", er);
						this.show_progress = false;						
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						});
					})
				}else{
					this.show_progress = false;						

					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message : this.$ml.get('req_name_file_upload') 
					});
				}

			}, // save image


			get_devices(){

				
				
				if (localStorage.getItem('list_devices')) {					
					const list_temp_device  = JSON.parse(localStorage.getItem('list_devices'));
					this.list_device 		= list_temp_device;
					this.listed 			= list_temp_device;
				} 
				if (this.list_device && this.list_device.length > 0) {
					this.options.itemsPerPage = this.list_device.length === 1 ? 1 :  this.list_device.length - 1;
					this.total 				  = this.options.itemsPerPage;
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('req_created_devices')
					})
					this.$router.push('device')
				}
				
			}, // get devices

			redirect(url, type){
				// localStorage.setItem('constellation', JSON.stringify(type));
				// this.$router.push({ name: url });
			}, // redirect

			save(){
				if (!this.$store.getters["auth/permission"]( this.$route.name || "settings_zones", "can_add", "zones")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_create") + " : " + (this.$ml.get(this.$route.name) || "settings_zones"),
					})						
					this.show_progress = false;
					this.actions_comp  = '';					
					return false;
				}
				let info_up = this.info;
				console.log("save : ", info_up)
				if (info_up && info_up.name) {

					const api  	= this.$URL + '/api/v1/constellation';
					this.$axios.post(api, info_up).then( res => {					
						this.save_local(res.data, true);
						this.show_progress = false;
						this.actions_comp  = '';
					}).catch( er => {
						this.show_progress = false;
						this.actions_comp  = '';					
						console.log(er, 'Error create zone');
						this.$EventBus.$emit('notifications_modal', { type: 'error' });
					})
				}else{
					this.show_progress = false;
					this.actions_comp  = '';										
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('required') + ' : ' + this.$ml.get('name'),
					})
				}
			},

			save_local(item, opt){
				if (item) {

					let temp 	=	this.info
					let info_up = {
						id 		: 	item.id,
						name  	: 	temp.name,
						devices :   temp.devices,	
						points  :   temp.points,
					};

					let list_temp = [...this.list];
					// info_up.id = Math.round(Math.random()*10); // item.id

					list_temp.push(info_up);
					localStorage.setItem('constellations', JSON.stringify(list_temp));
					// this.dialog = false;
					if (opt) {
						this.$EventBus.$emit('notifications_modal', { type: 'saved' });
						this.show_progress = false;
						this.$router.back();
					}
					// this.$router.push('dashboard');
				}
			}, // save local

			update(){
				if (!this.$store.getters["auth/permission"]( this.$route.name || "settings_zones", "can_edit", "zones")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + (this.$ml.get(this.$route.name) || "settings_zones"),
					})						
					this.show_progress = false;
					this.actions_comp  = '';					
					return false;
				}
				let info_up = this.info;

				Array.prototype.diff = function(a) {
				    return this.filter(function(i) {return a.indexOf(i) < 0;});
				};
				info_up.unselected = this.devs_selecteds.diff(info_up.device);
				console.log("update : ", info_up);
				if (info_up && info_up.id) {

					const api = this.$URL + '/api/v1/constellation/' + info_up.id;
					this.$axios.put(api, info_up).then( res => {
						console.log(res, 'Res update zone');					
						this.update_local(res.data, true);
						this.show_progress = false;
						this.actions_comp  = '';
					}).catch( er => {
						this.show_progress = false;
						this.actions_comp  = '';					
						console.log(er, 'Error update zone');
						this.$EventBus.$emit('notifications_modal', { type: 'error', message : er });
					})
				}else{
					this.show_progress = false;
					this.actions_comp  = '';										
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('req_id_to_update'),
					})
				}
			},
			update_local(){
				const info_up 	= this.info;
				let list_temp 	= [];
				let vn  		= this;
				const api 		= this.$URL + '/';
				/*this.$axios.put(api, info_up).then( res => {
					console.log(res, ' Res update constellation');

				}).catch( er => {
					console.log(er, ' Error update constellation');
				})*/

				const finded = vn.list.some( function(arr_list, idx_list){
					if (arr_list.id == info_up.id) {
						vn.list[idx_list] = {...info_up};

						return true
					}
				})
				console.log(finded, info_up, this.list, "Update local")
				if (finded) {
					list_temp = JSON.stringify([...this.list]);
					localStorage.setItem('constellations', list_temp);
					this.$EventBus.$emit('notifications_modal', { type: 'updated' });
					this.$router.back();
				}else{
					this.save_local();
					this.$router.back();

				}
				this.show_progress = false;
			}, // update

			delete(){
				if (!this.$store.getters["auth/permission"]( this.$route.name || "settings_zones", "can_delete", "zones")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + (this.$ml.get(this.$route.name) || "settings_zones"),
					})						
					this.show_progress = false;										
					return false;
				}
				const info_up = this.info;
				if (info_up && info_up.id) {


					const api = this.$URL + '/api/v1/constellation/' + info_up.id;
					this.$axios.delete(api).then( res => {
						this.delete_local();
						// this.update_local(res.data, true);
						this.show_progress = false;

					}).catch( er => {
						console.log(er, 'Error update zone');
						this.show_progress = false;
						
						EventBus.$emit('notifications_modal', { 
							type 	: 'error', 
							message : er 
						});
					})
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('req_id_del')
					})
				}
				

			}, // delete

			delete_local(){
				const info_up 	= this.info;
				let list_temp 	= [];
				let vn 			= this;

				const finded = vn.list.some( function(arr_list, idx_list){
					if (arr_list.id == info_up.id) {
						vn.list.splice(idx_list,1);
						return true
					}
				})
				if (finded) {
					list_temp = JSON.stringify(this.list);
					
					localStorage.setItem('constellations', list_temp);
					this.$EventBus.$emit('notifications_modal', { type: 'deleted' });
				}else{
					this.$EventBus.$emit('notifications_modal', { type: 'deleted' });
				}
				this.show_progress = false;
				// Evitar NavigationDuplicated
				if (this.$route.name !== 'zones') {
					this.$router.push('zones').catch(err => {
						if (err.name !== 'NavigationDuplicated') throw err;
					});
				}
			}, // delete local

			render_listed(list){
				if (list && this[list]) {
					return this[list];
				}
				return [];
			}, // render listed 

		}, // methods

		computed: {
			render_list: function() {
				return  this.listed;  //JSON.parse(localStorage.getItem('list_devices'));//
			}, 
		}, // computed

		mounted(){

			let id = 'notifications_modal' + (this.info.id || this.ID_notification) ;
			this.ID_notification = this.info.id || this.ID_notification;
			this.$EventBus.$on(id, this.bus[id] = (action) => {
				console.log(action, 'action del');
				if (action){
					this.delete();
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, this.ID_notification)
		}, // before destroy

	};
</script>
